import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'cc-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss']
})
export class SearchInputComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() controlName: string;
  @Input() placeholder = '';

  constructor() {}

  ngOnInit() {}
}
